(function () {
    'use strict';

    function questionViewModelConfigurationService() {
        var namespace = "Ecap.Api";

        var questionTypes = [
            {
                $type: namespace + ".ViewModels.FreeFormTextQuestionViewModel, " + namespace,
                name: "Free form text question with one line answer",
                template: { FreeFormTextQuestionFlavor: "SingleLine"}
            },
            {
                $type: namespace + ".ViewModels.FreeFormTextQuestionViewModel, " + namespace,
                name: "Free form text with multi-line answer",
                template: { FreeFormTextQuestionFlavor: "MultiLine" }
            },
            {
                $type: namespace + ".ViewModels.YesNoQuestionViewModel, " + namespace,
                name: "Yes/No question",
                template: {
                    CanSkip: false,
                    Value: false
                }
            },
            {
                $type: namespace + ".ViewModels.YesNoQuestionViewModel, " + namespace,
                name: "Yes/No/Skipped question",
                template: {
                    CanSkip: true
                }
            },
            {
                $type: namespace + ".ViewModels.OptionsQuestionViewModel, " + namespace,
                name: "Check box list question (select multiple answers)",
                template: {
                    Options: [
                    ],
                    IsMultiSelect: true
                }
            },
            {
                $type: namespace + ".ViewModels.OptionsQuestionViewModel, " + namespace,
                name: "Drop down list question (select one answer)",
                template: {
                    Options: [
                    ],
                    IsMultiSelect: false
                }
            }
        ];

        var buildQuestion = function (questionName, prompt) {
            var matchingQuestionType = questionTypes.find(function (qType) {
                return qType.name === questionName;
            })
            var newQuestion = Object.assign ({ $type: matchingQuestionType.$type }, matchingQuestionType.template);
            if (prompt && prompt.length > 0) {
                newQuestion.Prompt = prompt;
                newQuestion.Title = prompt;
            }

            return newQuestion;
        }

        return {
            questionTypes: questionTypes,
            buildQuestion: buildQuestion
        };
    }

    questionViewModelConfigurationService.$inject = [];

    angular.module('ecap.common').service('questionViewModelConfigurationService', questionViewModelConfigurationService);
})();
